import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as GC from "../../../../common/common";

class CreateArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      naam: "",
      code: GC.CodeAutoFill("GE"),
      omschrijving: "",
      active: true,
    };

    this.baseState = this.state;
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit() {
    $("#cover-spin").show(0);

    var model = {
      content: {
        algemeen: {
          actief: this.state.active,
          omschrijving: this.state.omschrijving,
          naam: this.state.naam,
          code: this.state.code,
        },
      },
      relationships: {
        definition: {
          code: "GEBIED",
        },
      },
    };

    omnimap
      .SaveOrEditAction(
        model,
        "POST",
        "",
        window.$catalog_management_units_token
      )
      .then((data) => {
        CallBackFunctions.areaSavedCallBack(
          window.$catalog_management_units_token
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }
  resetForm = async () => {
    await this.setState(this.baseState);
  };

  async componentDidMount() {
    const _this = this;
    $(document).on("click", "#beheereenheid_toevoegen", function () {
      $("#beheereenheid_toevoegen_modal").modal("show");
      _this.resetForm()
    });
  }

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="beheereenheid_toevoegen_modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Nieuw Gebied</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <label>Naam *</label>
              <input
                id="c-area-naam"
                type="input"
                className="form-control"
                placeholder="Naam"
                name="naam"
                value={this.state.naam}
                onChange={this.handleInputChange}
              />
              <label>Code</label>
              <input
                id="c-area-naam"
                type="input"
                className="form-control"
                placeholder="Code"
                name="code"
                value={this.state.code}
                onChange={this.handleInputChange}
              />
              <label>Omschrijving</label>
              <input
                id="beheereenheid_code"
                type="input"
                className="form-control"
                placeholder="Omschrijving"
                name="omschrijving"
                value={this.state.omschrijving}
                onChange={this.handleInputChange}
              />

              <label>Actief</label>
              <label className="switch">
                <input
                  id="beheereenheid_active"
                  type="checkbox"
                  defaultChecked
                  name="active"
                  value={this.state.active}
                  onChange={this.handleInputChange}
                />
                <span className="slider-checkbox round" />
              </label>
              <br />
              <br />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateArea;
